<template>
  <div class="form">
    <div class="form__content">
      <IdentityQueueStepCounter />
      <h1 class="large-headline">{{ form.identityTitle }}</h1>
      <p class="bodycopy">
        {{ $t("PageSubTitle.paragraph.dLocalInstructions") }}
        {{ identityType.toUpperCase() }}.
      </p>
      <form @submit.prevent>
        <!-- mask="###-##-####" -->
        <FormInputField
          :name="identityType"
          :label="form.inputLabel"
          :placeholder="form.inputPlaceholder"
          type="text"
          :inputValue="form.identityNumber"
          :errors="dlocalIdentityStore.getErrorByField(identityType)"
          v-model:curp="form.identityNumber"
          @update:curp="updateStoreWithValue"
          v-model:cpf="form.identityNumber"
          @update:cpf="updateStoreWithValue"
          v-model:said="form.identityNumber"
          @update:said="updateStoreWithValue"
          v-model:cc="form.identityNumber"
          @update:cc="updateStoreWithValue"
          v-model:dni="form.identityNumber"
          @update:dni="updateStoreWithValue"
          v-model:ci="form.identityNumber"
          @update:ci="updateStoreWithValue"
          v-model:tic="form.identityNumber"
          @update:tic="updateStoreWithValue"
          prevent-spaces="true"
          @keydown.space.prevent
          @paste="removeEventSpaces"
          @drop="removeEventSpaces"
        />
        <ButtonBase
          @onButtonClick="handleIdentitySubmission"
          :isLoading="globalStore.getIsFormLoading"
          :isDisabled="
            dlocalIdentityStore.formHasErrors || globalStore.getIsFormLoading
          "
        >
          {{ $t("ButtonBase.label.submit") }}
        </ButtonBase>
        <IdentityQueueNext />
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

import { useRouter, useRoute } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";
import { useDlocalIdentityStore } from "@/stores/forms/dlocalIdentityFormStore";

import useApiHelpers from "@/composables/api/helpers";

import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";
import FormInputField from "@/components/ui/inputs/FormInputField.vue";
import IdentityQueueStepCounter from "@/components/layout/progress/IdentityQueueStepCounter.vue";
import IdentityQueueNext from "@/components/layout/progress/IdentityQueueNext.vue";

const route = useRoute();
const router = useRouter();
const identityQueueStore = useIdentityQueueStore();
const globalStore = useGlobalStore();
const dlocalIdentityStore = useDlocalIdentityStore();

const { postRequest } = useApiHelpers();

const identityType = ref("");

const form = ref({
  inputLabel: dlocalIdentityStore.form[identityType.value]?.label || "",
  inputPlaceholder:
    dlocalIdentityStore.form[identityType.value]?.placeholder || "",
  identityTitle: dlocalIdentityStore.form[identityType.value]?.title || "",
  identityNumber: dlocalIdentityStore.form[identityType.value]?.value || "",
  payloadKey: "",
});

const handleIdentitySubmission = async () => {
  const formData = new FormData();
  formData.set(form.value.payloadKey, form.value.identityNumber.trim());
  globalStore.setIsFormLoading(true);
  postRequest(
    `/prepaid/dlocal/identity/${identityType.value}`,
    formData,
    () => {
      identityQueueStore.updateToNextRoute();
      identityQueueStore.fetchNextIdentityRoute(route).then((nextRoute) => {
        router.push(nextRoute);
      });
    },
    ({ error }) => {
      if (error) {
        globalStore.setIsFormLoading(false);
        dlocalIdentityStore.updateErrorFieldByKey(identityType.value, error);
      }
    }
  );
};

const setupIdentityForm = () => {
  identityType.value = route.params.type;
  form.value.payloadKey = `dlocal${
    identityType.value.charAt(0).toUpperCase() + identityType.value.slice(1)
  }`;
  form.value.inputLabel =
    dlocalIdentityStore.form[identityType.value].label || "";
  form.value.inputPlaceholder =
    dlocalIdentityStore.form[identityType.value].placeholder || "";
  form.value.identityTitle =
    dlocalIdentityStore.form[identityType.value].title || "";
  form.value.identityNumber =
    dlocalIdentityStore.form[identityType.value].value || "";
};

onMounted(() => {
  setupIdentityForm();
  dlocalIdentityStore.updateRequiredAndErrorFieldForNotSelectedKeys(
    identityType.value
  );
});

const updateStoreWithValue = (newValue) => {
  dlocalIdentityStore.updateValue(identityType.value, newValue);
};

const removeEventSpaces = (e) => {
  e.preventDefault();
  const left = e.target.value.substring(0, e.target.selectionStart);
  const right = e.target.value.substring(
    e.target.selectionEnd,
    e.target.value.length
  );
  const pasted = (e.dataTransfer || e.clipboardData)
    .getData("text")
    .replace(/ /g, "");
  e.target.value = left + pasted + right;
};
</script>

<style scoped></style>
